import React from 'react';

import Conditional from '../../common/conditional';
import PDFImage from './pdfImage';

import { getOptimizedImageURL, preventImageCaching } from '../../../utils/utilities';
import { PDFImageProps } from '../../../utils/models';

import classNames from './pdf.module.scss';

interface PDFPhotoPageProps {
	photos: PDFImageProps[];
}

const PDFPhotoPage: React.FC<PDFPhotoPageProps> = ({ photos }) => {
	const getPhotoClassName = (): string => {
		let isMultipleImages = photos.length > 1;
		let defaultName = `col${isMultipleImages ? '-6' : ''} mt-1 `;

		defaultName += isMultipleImages
			? classNames['pdf-image-container']
			: classNames['pdf-image-single'];

		return defaultName;
	};

	return (
		<Conditional isVisible={photos.length > 0}>
			<div className="row p-1">
				{photos
					.filter((photo) => photo.src)
					.map((photo, index: number) => (
						<React.Fragment key={photo.refNo}>
							<div className={getPhotoClassName()}>
								<PDFImage
									refNo={photo.refNo}
									src={preventImageCaching(getOptimizedImageURL(photo.src))}
									caption={`Photo ${photo.refNo}: ` + photo.caption}
								/>
							</div>

							<Conditional isVisible={(index + 1) % 2 === 0}>
								<div className="w-100"></div>
							</Conditional>
						</React.Fragment>
					))}
			</div>
		</Conditional>
	);
};

export default PDFPhotoPage;
